import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://rcyfuqhvepjazgqupycs.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJjeWZ1cWh2ZXBqYXpncXVweWNzIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzQzMDMwNDUsImV4cCI6MTk4OTg3OTA0NX0.dsF72KtkI2NGazBZcBWq6MwP80gkYcUCu_K-MLGd9lA"


export const supabase = createClient(supabaseUrl, supabaseAnonKey)